import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getAllUsersStart, clearAllUsers } from '../../../store/redux-slices/userSlice'
import { restoreUserStart } from '../../../store/redux-slices/fetchData'

import { getDateDaysAgo, convertToEasternISO } from '../../../utils/dateFormatter'
import useDidMountEffect from '../../../utils/useDidMountEffect'
import { selectUserData } from '../../../store/selectors/fetchData'
import { getDateRangeByFilter, defaultDateFilter } from '../../../utils/helpers';
import { toast } from "../../../components/Toast";
import { use } from 'react'
import { getLoginToken } from '../../../utils/storageUtils';

const useAllUserListing = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isInitialRender = useDidMountEffect()

  const [limit, setLimit] = useState(15)
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [affiliateSearch, setAffiliateSearch] = useState('')
  const [selectedClient, setSelectedClient] = useState('')
  const [selectedPortal, setSelectedPortal] = useState('')
  const [kycOptions, setKycOptions] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [activeUserId, setUserId] = useState('')
  const [orderBy, setOrderBy] = useState('userId')
  const [sortBy, setSortBy] = useState('desc')
  const [over, setOver] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState(defaultDateFilter);
  const [restoreUser, setRestoreUser] = useState({ isOpen: false, data: "" })
  const [deletedFilter, setDeletdFilter] = useState("")
  const [playerStatus, setPlayerStatus] = useState("")
  const [promoCode, setPromoCode] = useState('');

  const [state, setState] = useState(() => {
    const { startDate, endDate } = getDateRangeByFilter(defaultDateFilter);
    return [
      {
        startDate,
        endDate,
        key: "selection"
      }
    ];
  });

  const { userData, loading } = useSelector(selectUserData)
  const totalPages = userData?.pagination?.totalPages
  const totalCount = userData?.pagination?.total

  const selected = (h) =>
    orderBy === h.value &&
    (h.value === 'email' || h.value === 'userId' || h.value === 'username')

  const fetchData = () => {
    // Convert dates to Eastern timezone for API
    const startDate = state.map(a => a.startDate)[0]
    const endDate = state.map(a => a.endDate)[0]

    dispatch(
      getAllUsersStart({
        limit,
        pageNo: page,
        tenantId: selectedPortal,
        adminId: selectedClient,
        search: search.replace('+', '%2B'),
        kycStatus: kycOptions,
        affiliateSearch,
        dobStart: convertToEasternISO(startDate, 0, 0, 0, 0),
        dobEnd: convertToEasternISO(endDate, 23, 59, 59, 999),
        userId: activeUserId,
        phoneNumber,
        orderBy,
        sortBy,
        isDeleted: deletedFilter,
        isActive: playerStatus,
         promoCode,
      })
    )
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (page === 1) {
          const startDate = state.map(a => a.startDate)[0]
          const endDate = state.map(a => a.endDate)[0]

          dispatch(
            getAllUsersStart({
              limit,
              pageNo: page,
              tenantId: selectedPortal,
              adminId: selectedClient,
              search: search.replace('+', '%2B'),
              kycStatus: kycOptions,
              affiliateSearch,
              dobStart: convertToEasternISO(startDate, 0, 0, 0, 0),
              dobEnd: convertToEasternISO(endDate, 23, 59, 59, 999),
              userId: activeUserId,
              phoneNumber,
              orderBy,
              sortBy,
              isDeleted: deletedFilter,
              isActive: playerStatus,
               promoCode,
            })
          )
        } else {
          setPage(1)
        }
      }
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [search, affiliateSearch, activeUserId, phoneNumber, deletedFilter, playerStatus, promoCode])

  useEffect(() => {
    !isInitialRender && fetchData()

    return () => dispatch(clearAllUsers())
  }, [page])

  useEffect(() => {
    setPage(1)
    fetchData()

    return () => dispatch(clearAllUsers())
  }, [limit, selectedPortal, kycOptions, selectedClient, state, orderBy, sortBy])

  const getCsvDownloadUrl = () => {
    const startDate = state.map(a => a.startDate)[0]
    const endDate = state.map(a => a.endDate)[0]
    return `${process.env.REACT_APP_API_URL}/api/admin/user/all?csvDownload=true&search=${search.replace('+', '%2B')}&kycStatus=${kycOptions}&affiliateSearch=${affiliateSearch}&dobStart=${convertToEasternISO(startDate, 0, 0, 0, 0) || ''}&dobEnd=${convertToEasternISO(endDate, 23, 59, 59, 999) || ''}&userId=${activeUserId}&phoneNumber=${phoneNumber}&orderBy=${orderBy}&sort=${sortBy}&isDeleted=${deletedFilter || ''}&isActive=${playerStatus || ''}&promoCode=${promoCode || ''}&token=${getLoginToken()}`
  }

  const onResetDateFiltered = () => {    setSelectedFilter(defaultDateFilter)
    const { startDate, endDate } = getDateRangeByFilter(defaultDateFilter);
    setState([
      {
        startDate,
        endDate,
        key: "selection"
      }
    ]);
    setDeletdFilter("")
    setPlayerStatus("")
    setPromoCode('')
  }

  const onHandleRestoreduser = (data) => {
    // dispatch(restoreUserStart({ userId: restoreUser?.data.userId }))

    dispatch(restoreUserStart({
      data: { userId: restoreUser?.data.userId },
      onSuccess: () => {
        toast('Player Restored successfully', 'success')
        page === 1 ? fetchData() : setPage(1);
        setRestoreUser({ isOpen: false, id: "" })
      },
      onError: (error) => {
        // toast(error.message || 'Something went wrong', 'error')
      }
    }))

  }

  return {
    limit,
    setLimit,
    page,
    setPage,
    search,
    setSearch,
    userData: userData?.result || [],
    totalPages,
    navigate,
    affiliateSearch,
    setAffiliateSearch,
    selectedClient,
    selectedPortal,
    setSelectedPortal,
    setSelectedClient,
    loading,
    kycOptions,
    setKycOptions,
    state,
    setState,
    activeUserId,
    phoneNumber,
    setUserId,
    setPhoneNumber,
    orderBy,
    setOrderBy,
    sortBy,
    setSortBy,
    over,
    setOver,
    selected,
    setSelectedFilter,
    selectedFilter,
    onResetDateFiltered,
    restoreUser, setRestoreUser,
    onHandleRestoreduser,
    deletedFilter, setDeletdFilter,
    playerStatus, setPlayerStatus,
    totalCount,
    promoCode,
    setPromoCode,
    getCsvDownloadUrl,
  }
}

export default useAllUserListing
